module.exports = require('./helpers/bundle-url').getBundleURL('5VLtp') + "earth.0528b274.webp";